import { render, staticRenderFns } from "./Step3SelectQuestions.vue?vue&type=template&id=4b8c8858&scoped=true&"
import script from "./Step3SelectQuestions.vue?vue&type=script&lang=js&"
export * from "./Step3SelectQuestions.vue?vue&type=script&lang=js&"
import style0 from "./Step3SelectQuestions.vue?vue&type=style&index=0&id=4b8c8858&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c8858",
  null
  
)

export default component.exports